export default __webpack_public_path__ + "static/media/fitness.3daf7a6d.svg";